<script lang="ts">
	import {
		fetchAnnouncement,
		type Announcement,
		type AnnouncementResponse,
	} from "#lib/utils/fetchAnnouncement.js";
	import { PortableText } from "@portabletext/svelte";
	import theTime from "@ishavskraft/the-time";
	import { onMount } from "svelte";

	const shouldShow = (announcement: Announcement) => {
		if (!announcement?.active) return false;
		const time = theTime();
		const from = theTime(announcement.from);
		const to = theTime(announcement.to);
		return !((from.isValid() && time < from) || (to.isValid() && time > to));
	};

	let result: undefined | AnnouncementResponse = $state();

	onMount(async () => {
		result = await fetchAnnouncement();
	});
</script>

{#if result?.data && shouldShow(result.data)}
	<div class="wrapper mb-4">
		<div class="bg-uer-40 px-edge-x">
			{#each result.data.announcement as a (a)}
				<PortableText value={a} />
			{/each}
		</div>
	</div>
{/if}

<style lang="postcss">
	.wrapper {
		animation: grow-down var(--easing) var(--duration, 0.5s) forwards;
		display: grid;

		> div {
			overflow: hidden;
		}
	}

	@keyframes grow-down {
		from {
			grid-template-rows: 0fr;
		}
		to {
			grid-template-rows: 1fr;
		}
	}
</style>
